var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{class:'text-center ' + _vm.additionalClasses},[_vm._v(_vm._s(_vm.helpForm))]),_c('td',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(_vm.code))])])])}
var staticRenderFns = []

export { render, staticRenderFns }